{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Lykilorð",
      "PLACEHOLDER": "Lykilorð",
      "ERROR": "Lykilorið er of stutt."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Confirm Password",
      "ERROR": "Passwords do not match."
    },
    "API": {
      "SUCCESS_MESSAGE": "Successfully changed the password.",
      "ERROR_MESSAGE": "Náði ekki að tengjast við netþjóna Woot, vinsamlegast reynið aftur"
    },
    "CAPTCHA": {
      "ERROR": "Staðfesting rann út. Vinsamlegast leystu captcha aftur."
    },
    "SUBMIT": "Senda"
  }
}
